import { ErrorEntity, SitecoreTrialContentType } from '../types';

export const getErrorMessage = (data: SitecoreTrialContentType, code: string, email?: string) => {
  const error = data.errors.find((err: ErrorEntity) => err.code === code.toString());

  // If error message exists, replace [email] with the provided email, if email is supplied
  return error ? (email ? error.message.replace('[email]', email) : error.message) : null;
};
